import '@fontsource-variable/instrument-sans';
import './styles/index.css';
import { bindHelp, initBindings } from './bindings.js';
import { cloudBoot } from './cloud/boot.js';
import { S, persist } from './state.js';
import { applyTheme, initTheme } from './theme.js';
import { render } from './ui.js';
import { captureDeepLink } from './notify/deeplink.js';
import { captureJoin } from './team/team.js';
import { captureSecure } from './cloud/devices.js';
import { initInstall } from './notify/install.js';
import { registerSW } from './notify/push.js';
import { initUpdateCheck } from './notify/update.js';

/* /p/<token>: the read-only page for parents, without the app around it */
const PARENT=/^\/p\/[a-f0-9]{48,96}\/?$/.test(location.pathname);
if(PARENT)import('./parent/page.js').then(m=>m.parentPage());
else bootApp();

function bootApp(){
  /* the sales page's Team button: ?for=school pre-selects "my tutoring school" at sign-up */
  try{const q=new URLSearchParams(location.search);
    if(q.get('for')==='school'){localStorage.setItem('plume.intent','school');q.delete('for');history.replaceState(null,'',location.pathname+(q.toString()?'?'+q:'')+location.hash)}}catch(e){}
  /* the sales page passes the visitor's language: ?lang=de|en|fr */
  try{const q=new URLSearchParams(location.search);const l=q.get('lang');
    if(['de','en','fr'].includes(l)){S.settings.lang=l;persist();q.delete('lang');history.replaceState(null,'',location.pathname+(q.toString()?'?'+q:'')+location.hash)}}catch(e){}
  captureDeepLink();
  captureSecure();
  captureJoin();
  initInstall();

  applyTheme();
  initTheme();
  initBindings();
  bindHelp();
  render();
  import('./bg3d.js').then(m=>m.initBG()).catch(()=>{});
  cloudBoot();
  registerSW();
  initUpdateCheck();
  const railT=document.getElementById('railtoggle');
  if(railT)railT.onclick=()=>{
    const mini=document.documentElement.getAttribute('data-rail')==='mini';
    if(mini)document.documentElement.removeAttribute('data-rail');
    else document.documentElement.setAttribute('data-rail','mini');
    S.settings.rail=mini?'full':'mini';
    persist();
  };
}
